import { render } from "./BaseSearch.vue?vue&type=template&id=5a05c048&scoped=true"
import script from "./BaseSearch.vue?vue&type=script&lang=js"
export * from "./BaseSearch.vue?vue&type=script&lang=js"

import "./BaseSearch.vue?vue&type=style&index=0&id=5a05c048&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a05c048"]])

export default __exports__